import { Row, Card, Typography, Col, Avatar, Image } from "antd";
import { BorderBottomOutlined } from "@ant-design/icons";
import { getCardStyle } from "../../../utils/getCardStyle";

const { Text } = Typography;

const TodosCard = ({
  id,
  item,
  darkMode,
  getColorEstado,
  ordenActiva,
  setModalVisible,
  handleSelectForPalet,
  getTotalAuditadoYConteoPalets,
  esRecepcionMercaderia,
}) => {
  const tienePalet = esRecepcionMercaderia;
  const { totalAuditado, conteoPalets } = getTotalAuditadoYConteoPalets(item);

  const norm = (v) => (v == null ? "" : String(v).trim());
  const normVto = (v) => norm(v).replaceAll("-", "");

  if (item?.vto || item?.lote) {
    return;
  }

  return (
    <Col
      id={id}
      span={24}
      // key={`${item.idartp}-${item.nropar}-${item.sku}`}
      key={`${norm(item.sku)}|${norm(item.nropar)}|${norm(item.lote)}|${normVto(item.vto)}`}
      style={{ display: "flex", scrollMarginTop: "70px" }}
    >
      <Card
        hoverable
        styles={{ body: { padding: 16 } }}
        style={{
          cursor: tienePalet ? "pointer" : "default",
          ...getCardStyle(darkMode),
          backgroundColor: getColorEstado(item),
          height: "100%",
          flex: 1,
          transition: "background-color 0.2s linear",
        }}
      >
        {/* FILA 1: SKU */}
        <Row justify="space-between" align="top" wrap={false}>
          <Col style={{ minWidth: 0 }}>
            <Text
              strong
              style={{
                fontSize: "20px",
                color: "#000",
                display: "block",
                wordBreak: "break-word",
                overflowWrap: "anywhere",
              }}
            >
              {item.sku || "-"}
              {item?.ctdpar > 1 && item.articuloparte_numeroparte
                ? `-${String(item.articuloparte_numeroparte).padStart(2, "0")}`
                : ""}
            </Text>
          </Col>
        </Row>

        {/* FILA 2: Nombre + Modelo + Avatar */}
        <Row justify="space-between" align="top" wrap style={{ marginTop: 8 }}>
          <Col flex="auto" style={{ minWidth: 0 }}>
            <Text
              style={{
                display: "block",
                color: "#000",
                fontSize: "15px",
                wordBreak: "break-word",
                overflowWrap: "anywhere",
                marginBottom: 4,
              }}
            >
              {item.nombre}
            </Text>

            <Text strong style={{ display: "block", color: "#000" }}>
              {item?.valcar}
            </Text>
            <Text
              style={{
                display: "block",
                color: "#000",
                fontSize: "15px",
                wordBreak: "break-word",
                overflowWrap: "anywhere",
              }}
            >
              {item.modelo}
            </Text>
          </Col>
          <Col flex="none" style={{ marginLeft: "auto" }}>
            <Avatar
              src="/assets/producto.png"
              size={60}
              style={{ backgroundColor: "#8f9ee0" }}
            />
          </Col>
        </Row>

        {/* FILA 3: Acciones + Cantidad */}
        <Row justify="space-between" align="middle" style={{ marginTop: 12 }}>
          {/* Grupo de acciones: se contrae en mobile */}
          <Col style={{ minWidth: 0 }}>
            <div
              style={{
                display: "flex",
                gap: 8,
                alignItems: "center",
                flexWrap: "wrap", // ← permite que los elementos se apilen si no caben
                justifyContent: "flex-start",
              }}
            >
              {/* Ícono del teclado */}
              {ordenActiva && Number(item.ctdaud) >= 1 && (
                <Image
                  className="custom-icon"
                  src="/icons/keyboard.png"
                  preview={false}
                  style={{ width: 36, cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setModalVisible({
                      status: true,
                      payload: {
                        ...item,
                        sku: item.sku,
                        nombre: item.nombre,
                        parte: item.nropar,
                        modelo: item.modelo,
                        ubicacion: "-",
                        cantidad: item.cantid,
                        valorInicial: item.ctdaud,
                        idartp: item.idartp,
                        nropar: item.nropar,
                      },
                    });
                  }}
                />
              )}

              {/* Botón palet */}
              {ordenActiva && tienePalet && (
                <BorderBottomOutlined
                  className="custom-icon"
                  style={{
                    color: "#000",
                    fontSize: 31,
                    cursor: "pointer",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSelectForPalet(item);
                  }}
                />
              )}

              {/* Contador de palets */}
              {conteoPalets > 0 && (
                <Text
                  style={{
                    fontSize: "16px",
                    color: "#888",
                    whiteSpace: "nowrap",
                  }}
                >
                  (x{conteoPalets})
                </Text>
              )}
            </div>
          </Col>

          {/* Cantidad: se contrae si es necesario */}
          <Col style={{ minWidth: 0, textAlign: "right" }}>
            <Text
              strong
              style={{
                fontSize: "20px",
                color: "#000",
                wordBreak: "break-word",
                overflowWrap: "anywhere",
              }}
            >
              {totalAuditado} de {Number(item.cantid ?? 0)} Unid.
            </Text>
          </Col>
        </Row>
      </Card>
    </Col>
  );
};

export default TodosCard;
